export default __webpack_public_path__ + "static/media/icon_login.ce2e52f1.svg";